import { render, staticRenderFns } from "./CadastrarEditarGrupoDialog.vue?vue&type=template&id=564b27d4"
import script from "./CadastrarEditarGrupoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarGrupoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports